import React from "react";
import HelpCenter from "../../component/helpcenter/index";

export function Helpcenter() {
  return <HelpCenter />;
}
